var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ForgotPassword',{attrs:{"error_message":_vm.error_message,"loading":_vm.loading,"email_sent":_vm.email_sent},on:{"onSend":_vm.sendResetPassword}})}
var staticRenderFns = []

export { render, staticRenderFns }